import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Keyboard } from "./keyboard-CML2Vzkw.js";
import { t as Mousewheel } from "./mousewheel-C-gtMpkm.js";
//#region src/scripts/extenders/swiper.js
var SwiperElement = class extends HTMLElement {
	constructor() {
		super();
		new Swiper(this.querySelector(".swiper"), {
			modules: [Mousewheel, Keyboard],
			direction: "horizontal",
			mousewheel: { forceToAxis: true },
			keyboard: { enabled: true },
			spaceBetween: 12,
			slidesPerView: "auto"
		});
	}
};
if (customElements.get("swiper-holder") === void 0) customElements.define("swiper-holder", SwiperElement);
//#endregion
